import React from "react";
import { Box, Typography } from "@mui/material";
import Button from "./Button";

interface Props {
  name: string;
  extraInfo?: string;
  handleClose: () => void;
  handleDelete: () => void;
  loading?: boolean;
}

const DeleteConfirmation: React.FC<Props> = (props) => {
  const { name, extraInfo, handleClose, handleDelete, loading } = props;

  return (
    <Box margin={3}>
      <Typography variant="h4" justifyContent="center" textAlign="center">
        Are you sure you would like to delete {name}?
      </Typography>
      {!!extraInfo && (
        <Typography
          marginTop={4}
          variant="h5"
          justifyContent="center"
          textAlign="center"
        >
          {extraInfo}
        </Typography>
      )}
      <Box
        display="flex"
        flexDirection="row"
        width="100%"
        justifyContent="space-around"
        gap={2}
        marginTop={5}
      >
        <Box
          display="flex"
          flexDirection="column"
          justifyContent="center"
          color="text.secondary"
        >
          <Button label="Cancel" cancel onClick={handleClose} />
        </Box>
        <Box display="flex" flexDirection="column" justifyContent="center">
          <Button
            label="Delete"
            variant={"contained"}
            color={"secondary"}
            onClick={handleDelete}
            loading={loading}
          />
        </Box>
      </Box>
    </Box>
  );
};

export default DeleteConfirmation;
